export const statuses = {
	pending: 'PENDING',
	accepted: 'ACCEPTED',
	cooked: 'COOKED',
	pickedUp: 'ACCEPTED_TO_PICK_UP',
	inRestaurant: 'IN_RESTAURANT',
	collected: 'COLLECTED',
	delivered: 'DELIVERED',
	rejected: 'REJECTED',
};

export default [
	{ value: statuses.pending, prop: 'lastDatePending', label: 'Pending', mapIcon: 'inRestaurant', color: '#eead4a' },
	{
		value: statuses.accepted,
		prop: 'lastDateAccepted',
		label: 'Accepted',
		mapIcon: 'inRestaurant',
		color: '#5fbcde',
	},
	{ value: statuses.cooked, prop: 'lastDateCooked', label: 'Cooked', mapIcon: 'cooked', color: '#0fc4b3' },
	{
		value: statuses.pickedUp,
		prop: 'lastDateAcceptedToPickUp',
		label: 'Pickup',
		mapIcon: 'pickup',
		color: '#b882c4',
	},
	{
		value: statuses.inRestaurant,
		prop: 'lastDateInRestaurant',
		label: 'Restaurant',
		mapIcon: 'inRestaurant',
		color: '#35cd96',
	},
	{
		value: statuses.collected,
		prop: 'lastDateCollected',
		label: 'Collected',
		mapIcon: 'collected',
		color: '#b57e5b',
	},
	{ value: statuses.delivered, prop: 'lastDateDelivered', label: 'Delivered', mapIcon: 'cooked', color: '#8bb189' },
	{ value: statuses.rejected, prop: 'lastDateRejected', label: 'Rejected', mapIcon: 'delayed', color: '#c42b36' },
];
